module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module3-2.9872b2f1.jpg";